<template>
	<div class="section">
		<div class="container">
			<h1>Enforceability Index Methodology</h1>
			<div>
				The full methodology with more detailed information on each variable and the analytical process for the Index is available for review <a target="_blank" href="https://awg.aero/wp-content/uploads/2025/09/AWG-Enforceability-Index-Methodology.pdf">here</a>.
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {},
		mounted() {}
	};
</script>


